import { observer } from 'mobx-react';
import classnames from 'classnames';

import style from './DesktopView.module.scss';

import { TelLink } from '@components/TelLink';
import { TextLink } from '@components/TextLink';
import { LinkTarget } from '@components/TextLink/TextLink';

import { EhrRelation, ehrService } from '@patient/services/ehr/ehrService';
import { useDataLoading } from '@utils/hooks/useDataLoading';
import { store } from '@store';
import { Chat } from '@common/Chat/Chat';
import { PatientApp } from '@common/PatientApp';
import { isPatientAppEnabled } from '@common/PatientApp/utils/isPatientAppEnabled';

import { RepresentativesDropdown } from './RepresentativesDropdown';

interface DesktopViewProps {
    fullName: string;
    birthDate?: string;
    age: string;
    recordId: number;
    phone?: string;
    email?: string;
    link?: string;
    isPatientPage?: boolean;
}

export const DesktopView = observer(
    ({ fullName, birthDate, age, recordId, phone, email, link, isPatientPage }: DesktopViewProps) => {
        const { authUser, ehr, viewPort } = store;

        useDataLoading(async () => {
            if (authUser.isAssistant) {
                await ehrService.loadRelations([EhrRelation.AssistantsChatLink]);
            }
        }, [ehr.id]);

        return (
            <div className={style.root}>
                <div
                    className={style.fullName}
                    title={fullName}
                >
                    {link && !isPatientPage ? (
                        <TextLink
                            label={fullName}
                            link={link}
                            target={LinkTarget.SELF}
                            className={style.fullNameLink}
                        />
                    ) : (
                        fullName
                    )}
                </div>
                <RepresentativesDropdown />
                <div className={style.ehrDetail}>
                    {birthDate && (
                        <div className={style.text}>
                            {birthDate} / {age}
                        </div>
                    )}
                    <div className={style.text}>{recordId ? `№${recordId}` : ''}</div>
                    {phone && (
                        <div className={classnames([style.text, style.phoneText])}>
                            <TelLink
                                tel={phone}
                                withIcon
                                withCopy
                            />
                        </div>
                    )}
                    {isPatientAppEnabled() ? (
                        <PatientApp
                            hideAppLabel={viewPort.isTableSize}
                            hideSubscriptionLabel={viewPort.isTableSize}
                        />
                    ) : (
                        <Chat hideLabel={viewPort.isTableSize} />
                    )}
                </div>
            </div>
        );
    },
);
